import React from 'react';
import { ClaimResult } from '../hooks/useClaimScan';
import { T } from '../designTokens';

interface ClaimFeedbackProps {
  isClaiming: boolean;
  claimResult: ClaimResult | null;
  onClose: () => void;
}

export default function ClaimFeedback({ isClaiming, claimResult, onClose }: ClaimFeedbackProps) {
  if (!isClaiming && !claimResult) return null;

  return (
    <div style={{
      margin: '20px 0',
      padding: '20px',
      borderRadius: '12px',
      backgroundColor: isClaiming ? T.gray50 : claimResult?.type === 'success' ? T.green50 : T.errorBg,
      border: `1px solid ${isClaiming ? T.gray200 : claimResult?.type === 'success' ? T.green200 : T.errorBorder}`,
      textAlign: 'center'
    }}>
      {isClaiming ? (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
          <div className="claiming-spinner" style={{
            width: '24px',
            height: '24px',
            border: `3px solid ${T.gray200}`,
            borderTopColor: T.blue500,
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
          <p style={{ margin: 0, color: T.gray600, fontWeight: 500 }}>Saving your scan results...</p>
          <style>{`
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
            <span style={{ 
              fontSize: '20px', 
              color: claimResult?.type === 'success' ? T.green600 : T.error 
            }}>
              {claimResult?.type === 'success' ? '✓' : '⚠'}
            </span>
            <p style={{
              margin: 0,
              color: claimResult?.type === 'success' ? T.green800 : T.gradeF,
              fontWeight: 600
            }}>
              {claimResult?.type === 'success' ? 'Claimed' : 'Claim failed'}
            </p>
          </div>
          <p style={{ 
            margin: '0 0 12px', 
            color: claimResult?.type === 'success' ? T.green700 : T.red700,
            fontSize: '14px',
            lineHeight: '1.5'
          }}>
            {claimResult?.message}
          </p>

          <button 
            onClick={onClose}
            style={{
              padding: '6px 16px',
              borderRadius: '6px',
              backgroundColor: claimResult?.type === 'success' ? T.green600 : T.red500,
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: 500,
              alignSelf: 'center'
            }}
          >
            Dismiss
          </button>
        </div>
      )}
    </div>
  );
}
